import { message } from 'antd'

const messageDuration = 2

message.config({
  duration: messageDuration,
})
